/** Titles carry no identity — "Dr. Katherine Johnson" reads as KJ, not DJ. */
const HONORIFICS = new Set([
  "dr",
  "mr",
  "mrs",
  "ms",
  "mx",
  "prof",
  "professor",
])

/** Two-letter initials for avatar chips when only a display name is available (e.g. compliance owner). */
export function initialsFromDisplayName(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  const parts = words.filter(
    (part) => !HONORIFICS.has(part.replace(/\.$/, "").toLowerCase()),
  )
  const usable = parts.length > 0 ? parts : words
  if (usable.length === 0) return "?"
  if (usable.length === 1) return usable[0].slice(0, 2).toUpperCase()
  return (usable[0][0]! + usable[usable.length - 1]![0]!).toUpperCase()
}
